module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "preface"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('strong', [_c('em', [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("SOME WHO WERE THERE may question details in my reminiscence, and through time’s hazing parts of the story are admittedly knotty points in my memory. The quotes from documents are correct to the letter, and the places and situations are as true as time, the tide of recall, and the ebb and flow of keepsakes of the mind can ever be (sources for government documents are listed in the references). Some events, even certain conversations, flash back clearly, as if I’d tied a string around my finger to help hang on to them. Other mental souvenirs come back less clearly, sometimes helped by a nudge from my friends. I took no notes and the remarks and opinions are not presented as verbatim statements, but are rather intended to express the gist of what people had to say. If some of the original authors of these words find them garbled or unrecognizable, I apologize and admit the fault is probably mine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When I started to jot down my recollections it was only as an exercise to record the rather curious history of yet another in a long list of oddball wartime operations. I didn’t realize that there was a story woven into the tapestry of haphazard-seeming incidents and that lacing it all together would make a drama come clear. I didn’t know that I had been cast in a skit of hardly earthshaking importance, but a story nonetheless of intrigues, double-crosses, loyalties, loves, of larger human strengths and weaknesses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("All of this happened nearly fifty years ago, so if I’m muddled here and there, I hope I can be excused. But this is the way I remember it."), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-769c4412","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/preface.vue
// module id = 72
// module chunks = 0